import clsx from 'clsx'
import { StrapiV4RichTextEditor } from '../rich-text-editor/rich-text-editor'
import CardsGridV0Widget from '../cards-grid-v0/cards-grid-v0'
import StrapiV4Multimedia from '../../atoms-components/multimedia/multimedia'
import { getColorHexFromDotBrandColorNotation } from '@/stories/strapi-4/utils/colors'
import { TStrapiV4SectionCardFourWidget } from '@/stories/strapi-4/common-types'
import Title from '@/stories/strapi-4/common-components/Title'
import colors from '@ind-money/tailwind/tokens/colors'
import StrapiV4ChicletList from '../../molecules-components/chiclet-list/StrapiV4ChicletList'
import Link from '@/components/Common/Link'

type TProps = {
  data?: TStrapiV4SectionCardFourWidget
  notHero?: boolean
  hideCards?: boolean
}

const StrapiV4SectionCardTypeFourWidget = (props: TProps) => {
  const { data, notHero = false, hideCards = false } = props

  if (!data) return null

  const { bg_color, heading, sub_title } = data

  const bgColor = bg_color?.color
    ? getColorHexFromDotBrandColorNotation(bg_color.color)
    : bg_color?.custom_color
      ? bg_color.custom_color
      : colors.brand.white

  return (
    <div
      style={{
        backgroundColor: bgColor,
      }}
      className={clsx({
        'mb-8 py-8 xl:mb-12 xl:py-12': bgColor !== colors.brand.white,
      })}
    >
      <div
        className={clsx(' py-8  xl:py-12', {
          'herolike-wrapper lg:px-6': !notHero,
        })}
      >
        <div
          className={clsx('flex flex-col', {
            '!text-brand-white': bgColor === '#191C1F',
          })}
        >
          <div className="flex items-center pb-3 xl:pb-7">
            {data.heading_icon && (
              <div className="mr-5">
                <StrapiV4Multimedia data={data.heading_icon} />
              </div>
            )}
            {heading?.text && (
              <Title
                {...heading}
                fontSize={heading.fontSize ?? 'size-54'}
                className={clsx('font-semibold text-brand-black', {
                  '!text-brand-white': bgColor === '#191C1F',
                })}
              >
                {heading.text}
              </Title>
            )}
          </div>

          {sub_title?.rich_text_html && (
            <StrapiV4RichTextEditor
              content={sub_title.rich_text_html}
              className={clsx(
                'pb-6 text-lg text-brand-black/70 xl:pb-9 xl:text-[18px] xl:!leading-[36px]',
                {
                  '!text-brand-white': bgColor === '#191C1F',
                },
              )}
            />
          )}

          {!hideCards && data.cards_grid?.api_path && (
            <CardsGridV0Widget apiUrl={data.cards_grid.api_path} />
          )}

          {data.chiclet_list && (
            <StrapiV4ChicletList data={data.chiclet_list} />
          )}
          {data.green_cta?.url && (
            <Link
              href={data.green_cta.url}
              className="btn mx-auto mt-12 w-fit bg-brand-green-dark px-6 py-3 text-center text-base font-medium lg:mx-0 lg:w-[330px] lg:py-4 lg:text-lg"
            >
              {data.green_cta.text}
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

export default StrapiV4SectionCardTypeFourWidget
